var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('lottie-vue-player',{staticStyle:{"width":"80px","height":"80px"},attrs:{"src":`/animations/${_vm.animationName}.json`,"theme":_vm.options.theme,"player-size":_vm.options.playerSize,"player-controls":false,"autoplay":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }